import {UpdateAdvisingHeaderTaskRequest} from './receiving-instruction-header-updaterequest';
import {UpdateAdvisingDetailTaskRequest} from './receiving-instruction-detail-updaterequest';

export class UpdateReceivingTaskRequest {
  receivingTaskHeader?: UpdateAdvisingHeaderTaskRequest[] | undefined;
  receivingTaskDetail?: UpdateAdvisingDetailTaskRequest[] | undefined;
  forceSyncFlag: boolean;
  uuid?:string;
  language?:string;

  constructor() {
    this.receivingTaskHeader = [];
    this.receivingTaskDetail = [];
    this.forceSyncFlag = false;
    this.uuid = undefined;
    this.language = undefined;
  }
}
